import PropTypes from 'prop-types'
import React from "react"

import { Routes, Route } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes, partnerRoutes, promoRoutes, facultyRoutes, subAdminRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import PartnerLayout from "./components/PartnerLayout"
import PromoLayout from "./components/PromoLayout"
import SubAdminLayout from "./components/SubAdminLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./assets/scss/preloader.scss"
import "./App.css"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend"
import axios from "axios";
import Unauthorized from './pages/Unauthorized'
import RoleBasedMiddleware from './routes/middleware/RoleBasedMiddleware'

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = props => {

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()
  return (
    <React.Fragment>
      {/* <Router> */}
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />

        ))}

        {partnerRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <RoleBasedMiddleware allowedRoles={[1]}> {/* Only admins (role 1) */}
                <PartnerLayout>{route.component}</PartnerLayout>
              </RoleBasedMiddleware>
            }
            key={idx}
            exact
          />
        ))}

        {promoRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <RoleBasedMiddleware allowedRoles={[1]}>
                <PromoLayout>{route.component}</PromoLayout>
              </RoleBasedMiddleware>
            }
            key={idx}
            exact
          />
        ))}

        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <RoleBasedMiddleware allowedRoles={[1]}>
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              </RoleBasedMiddleware>
            }
            key={idx}
            exact
          />
        ))}

        {facultyRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <RoleBasedMiddleware allowedRoles={[1]}>
                <Authmiddleware>{route.component}</Authmiddleware>
              </RoleBasedMiddleware>
            }
            key={idx}
            exact
          />
        ))}

        {subAdminRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <RoleBasedMiddleware allowedRoles={[2]}>
                <Authmiddleware>
                  <SubAdminLayout>{route.component}</SubAdminLayout>
                </Authmiddleware>
              </RoleBasedMiddleware>
            }
            key={idx}
            exact
          />
        ))}

        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
